<template>
    <div>
        <general-header v-bind:content="{header: 'About Best Meta', subheader: '', buttonText: '', buttonIcon: '', buttonPosition: '', to: ''}"></general-header>

        <section class="about">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-10">

                        <h3>The Inspiration Behind Best Meta...</h3>

                        <p>Often times when looking to purchase an item on Amazon I've found that I like to base my purchase on what's popular. It's probably an unhealthy obsession with getting the best bang for my buck - but if I'm going to buy something I just figure why not have it be the well-tested and most-loved choice?</p>

                        <p>When an item is popular it signifies that there is a certain quality to it that people appreciate. It may be silly, but after some research I realized I wasn't alone in this habit! I would ask my friends and they all seemed to agree.</p>

                        <p>A main issue that I heard a lot of people specify is how hard it is to find those little yellow labels that Amazon puts on their best-selling products. I felt the same way - that there must be a way to make browsing the most popular items on Amazon easy - and dare I say it - enjoyable.</p>

                        <p>So that's how Best Meta was born - with the hopes of being the number one way to shop the best items sold on Amazon. If you have a question, please contact Beta Meta at innermonkdesign(at)gmail(dot)com. Any feedback or suggestions is always welcome.</p>

                        <p>Happy browsing!</p>

                        <p>- John</p>
                    </div>
                </div>
            </div>
        </section>

        <general-header
            v-bind:content="{
                header: 'Looking for the best products?',
                subheader: '',
                buttonText: 'Search',
                buttonIcon: 'search',
                iconPosition: 'left',
                to: 'home'
            }">
        </general-header>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'about',
    computed: {
        ...mapGetters({
            user: 'user/user'
        })
    },
    mounted () {
    }
}
</script>

<style lang="scss" scoped>

    .about {
        padding: 45px 0;
    }

</style>
